import { Form, Modal } from "antd";
import React from "react";
import { CreateAirSzzPointPollutantDto } from "../../../api";
import { AirSzzPointPollutantsColumns } from "../form/columns";

interface AirSzzPointPollutantFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateAirSzzPointPollutant: (values: CreateAirSzzPointPollutantDto) => void;
}

export const AirSzzPointPollutantForm: React.FC<AirSzzPointPollutantFormProps> = ({ visible, setVisible, onCreateAirSzzPointPollutant }) => {
  const [form] = Form.useForm<CreateAirSzzPointPollutantDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateAirSzzPointPollutant}>
        {AirSzzPointPollutantsColumns().map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
